
export interface AppConfig {
    serverUrl: string;
    apiRootUrl: string;
    clientUrl: string;
    basename: string;
    culture: string;
    style: string;
    authenticationTimeout: number;
    longPressMs: number;
    clientDatabaseName: string;
    googleApiKey: string;
    environmentName: string;
    environmentColor: string;
    buildDateStr: string;
    ssoIntegrations: string;
    ownerParameters: string;
    employeeGroupParameters: string;
}

const appConfig : AppConfig = {
    serverUrl: process.env.REACT_APP_ROOT_URL ?? "", // EasyOpp.Web
    apiRootUrl: process.env.REACT_APP_API_ROOT_URL ?? "", // EasyOpp.Api
    clientUrl: process.env.REACT_APP_OWN_URL ?? "",
    basename: process.env.REACT_APP_BASENAME ?? "",
    culture: "",
    style: "",
    authenticationTimeout: 0,
    longPressMs: 0,
    clientDatabaseName: "",
    googleApiKey: "",
    environmentName: "",
    environmentColor: "",
    buildDateStr: "",
    ssoIntegrations: "",
    ownerParameters: "",
    employeeGroupParameters: "",
};

export default appConfig;
